// removed by extract-text-webpack-plugin
module.exports = {"link":"_1FngI-KVDFTQVf8L0NR6Ye","projectInfoContainer":"_1LCSABwUSWlSsSkZTY4E89","img":"ES34-U7sLLdho2ZJrgfS3","tags":"_2j-Yxotqi_j3PhvEDY9GKD","name":"_2I2dPOS56I2b6kOKauGKzn","engName":"_1OF0Shn0EuyIZ1fip-4slE","chtName":"_2reUDqADDKizXUa6lcN7Oz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project-col/ProjectCol.css
// module id = 348
// module chunks = 0